module.exports = __webpack_public_path__ + "img/category.340099c0.svg";